'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  width:100%;\n  padding: 5px;\n  color: black;\n  background: white;\n  border: ', ';\n  border-radius: 3px;\n  box-sizing : border-box;\n  &:focus {\n    outline: none;\n  }\n'], ['\n  width:100%;\n  padding: 5px;\n  color: black;\n  background: white;\n  border: ', ';\n  border-radius: 3px;\n  box-sizing : border-box;\n  &:focus {\n    outline: none;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DInput = _styledComponents2.default.input(_templateObject, function (props) {
  return !props.showBorder ? 'none' : '1px solid';
});

var Input = function Input(props) {
  return _react2.default.createElement(DInput, _extends({}, props, {
    className: props.className
  }));
};

Input.propTypes = {
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-modern-datepicker/build/elements/Input.js
// module id = 477
// module chunks = 0